

<template>
	<div class="LowResultsSuggestions">
		<div
			v-if="lowResultSuggestionWithDiscipline && lowResultSuggestionWithDiscipline.countValues"
			class="LowFilterSuggestions"
		>
			<span class="LowResultTitle">
				{{ disciplineTitle }}
			</span>
			<LowResultSuggestion
				:filterSelection="lowResultSuggestionWithDiscipline"
			/>
		</div>

		<div
			v-if="lowResultsSuggestionsWithoutDiscipline.length > 0 &&
			lowResultsSuggestionsWithoutDiscipline.some(s => s.countValues && s.countValues > 0)"
			class="LowFilterSuggestions"
		>
			<span class="LowResultTitle">
				{{ locationTitle }}
			</span>
			<div>
				<LowResultSuggestion
					v-for="filter in lowResultsSuggestionsWithoutDiscipline"
					:key="filter.type"
					:filterSelection="filter"
				/>
			</div>
		</div>
	</div>
</template>

<script setup lang="ts">
import { useSearchStore } from '@app/stores/useSearchStore';
import LowResultSuggestion from '@app/components/SearchResults/LowResults/LowResultsSuggestions/LowResultSuggestion/LowResultSuggestion.vue';
import {  computed, ref } from 'vue';
import { FilterType } from '@studyportals/omnisearch-interfaces';
import { LOW_RESULTS_TITLE_FILTERTYPE_MAPPER } from '@domain/mappers/LowResultsFilterTypeMapper';

const searchStore = useSearchStore();
const lowResultSuggestionWithDiscipline = computed(() => searchStore.pageData?.lowResultsSuggestions?.find( x => x.type === FilterType.DISCIPLINES) );
const lowResultsSuggestionsWithoutDiscipline = computed(() => searchStore.pageData?.lowResultsSuggestions?.filter( x => x.type !== FilterType.DISCIPLINES) || []);

const disciplineTitle = ref(LOW_RESULTS_TITLE_FILTERTYPE_MAPPER.get(FilterType.DISCIPLINES));
const locationTitle = ref(LOW_RESULTS_TITLE_FILTERTYPE_MAPPER.get(FilterType.COUNTRY));
</script>

<style scoped lang="scss">
.LowResultsSuggestions {
	display: flex;
	flex-direction: column;
	gap: 0.5rem;

	.LowFilterSuggestions {
		display: flex;
		flex-direction: column;
		gap: 0.5rem;
	}

	.LowResultTitle {
		@include TextStyle(HeadingExtraSmall);
	}
}
</style>
